import React from 'react';

// components
import { shippingModal as messages } from '../shippingMessages';

// styles
import styles from './ShippingDetailsText.scss';

export function ShippingDetailsDisclaimer() {
    return (
        <div className={styles.detailsDisclaimers}>
            <p className={styles.detailsDisclaimer}>{messages.disclaimer}</p>
            <p className={styles.detailsDisclaimer}>{messages.legal}</p>
        </div>
    );
}
